import { PageLayout } from "@/components/layout/PageLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminHeader } from "@/components/admin/AdminHeader";
import { PageTitle } from "@/components/ui/page-title";
import { PageSubtitle } from "@/components/ui/page-subtitle";
import RolesTable from "@/domains/admin/components/organisms/RolesTable";

export default function RolesAdminPage() {
  return (
    <PageLayout headerButtons={<AdminHeader />}>
      <div className="mb-6">
        <PageTitle>Roles &amp; Permissions</PageTitle>
        <PageSubtitle>
          Define which permissions each role grants. Permissions themselves are seeded by migrations
          — this is for tweaking which role gets which subset, and for adding ad-hoc roles between
          releases.
        </PageSubtitle>
      </div>

      <Tabs defaultValue="roles" className="w-full">
        <TabsList>
          <TabsTrigger value="roles">Roles</TabsTrigger>
        </TabsList>

        <TabsContent value="roles" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Roles</CardTitle>
              <p className="text-sm text-muted-foreground">
                Each role bundles a set of permissions. Click the permission count in any row to add
                or remove permissions.
              </p>
            </CardHeader>
            <CardContent>
              <RolesTable />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </PageLayout>
  );
}
